import {createReducer} from 'redux-act'

import * as actions from "#app/store/actions/task";
import type {TaskFormTypeValue} from "#app/store/actions/task";

export const TASK_FORM_TYPES: Readonly<{ NEW: TaskFormTypeValue; EDIT: TaskFormTypeValue; EVENT: TaskFormTypeValue }> = Object.freeze({
  NEW: { id: 'new', title: 'Новое событие' },
  EVENT: { id: 'event', title: 'Событие' },
  EDIT: { id: 'edit', title: 'Редактирование' },
});

export interface TaskState {
  modalVisible: boolean;
  form: any;
  type: TaskFormTypeValue;
}

const task: TaskState = {
  modalVisible: false,
  form: {},
  type: TASK_FORM_TYPES.EVENT,
};

const setTaskModalVisible = (state: TaskState, bool: boolean): TaskState => {
  return {
    ...state,
    modalVisible: bool,
  }
}

const setTaskForm = (state: TaskState, form: any): TaskState => {
  return {
    ...state,
    form: form
  }
}

const setTaskType = (state: TaskState, type: TaskFormTypeValue | null = null): TaskState => {
  return {
    ...state,
    type: type ?? TASK_FORM_TYPES.NEW
  }
}


const reducer = createReducer<TaskState>((on) => {
  on(actions.setTaskModalVisible, setTaskModalVisible);
  on(actions.setTaskForm, setTaskForm);
  on(actions.setTaskType, setTaskType);
}, task)

export default reducer
